import { ScriptLoader } from 'script-loader';
import shortcutKeybindings from './shortcutKeyBindings';
import { IShortcutPanelManager, IShortcutPanelServiceDelegates } from '@src/slide/application/service/shortcut-panel/shortcut-panel-manager.interface';
import { RightSideBarModule } from '../right-side-bar-service/core/right-side-bar-module';

const MODULE_NAME = 'shortcut-panel';

export class ShortcutPanelRSBarModule extends RightSideBarModule {
    public get name() {
        return MODULE_NAME;
    }

    public constructor(private shortcutPanelManager: ShortcutPanelManager) {
        super();
    }

    public show() {
        this.shortcutPanelManager.showModule(this.DOMNode, () => {
            this.showWrapper();
        }, () => {
            this.hideWrapper();
        });
    }

    public wrapperDidHide() {
        this.shortcutPanelManager.removeModule();
    }
}

export default class ShortcutPanelManager implements IShortcutPanelManager {
    public module: any;
    private services: IShortcutPanelServiceDelegates;

    public setServiceDelegates(services: Partial<IShortcutPanelServiceDelegates>) {
        this.services = {
            ...this.services,
            ...services,
        };
    }

    public registerRightSideBar() {
        this.services.rightSideBarService.registerModule(new ShortcutPanelRSBarModule(this));
    }

    public showModule(DOMNode, onShow, onClose) {
        this.loadModule((isFirstLoad) => {
            if (isFirstLoad) {
                this.module?.init(DOMNode, {
                    shortcutKeybindings,
                    close: onClose,
                });
            }
            this.module?.show();
            onShow?.();
        });
    }

    public switchByShortcut() {
        if (this.services.rightSideBarService.isShown(MODULE_NAME)) {
            this.hide();
        } else {
            this.show();
        }
    }

    public show() {
        this.services.rightSideBarService.show(MODULE_NAME, undefined);
    }

    public removeModule() {
        // do nothing
    }

    public hide() {
        this.services.rightSideBarService.hide();
    }

    private loadModule(cb?: (isFirstLoad?: boolean) => void) {
        if (this.module) {
            cb?.();
        } else {
            // @ts-ignore
            ScriptLoader.load('ShortcutPanel', (module: any, isFirstLoad: any) => {
                this.module = module;
                cb?.(isFirstLoad);
            });
        }
    }
}
